export interface WebsiteMapping {
  channelId: number;
  locale: string;
  currency: string;
  entity: string;
  contactLocale: string;
  partnerKeyEnvVar?: string;
}

const DEFAULT_WEBSITE = "www.travelski.com";

const websiteMappings: Record<string, WebsiteMapping> = {
  "www.uk.travelski.com": {
    channelId: 71,
    locale: "en-US",
    currency: "GBP",
    entity: "travelski_uk",
    contactLocale: "TS-en_US",
  },
  "uk.travelski.com": {
    channelId: 71,
    locale: "en-US",
    currency: "GBP",
    entity: "travelski_uk",
    contactLocale: "TS-en_US",
  },
  "www.nl.travelski.com": {
    channelId: 72,
    locale: "nl-NL",
    currency: "EUR",
    entity: "travelski_nl",
    contactLocale: "TS-nl_NL",
  },
  "nl.travelski.com": {
    channelId: 72,
    locale: "nl-NL",
    currency: "EUR",
    entity: "travelski_nl",
    contactLocale: "TS-nl_NL",
  },
  "www.fr.yoonly.eu": {
    channelId: 80,
    locale: "fr-FR",
    currency: "EUR",
    entity: "yoonly_fr",
    contactLocale: "YN-fr_FR",
  },
  "www.nl.yoonly.eu": {
    channelId: 106,
    locale: "nl-NL",
    currency: "EUR",
    entity: "yoonly_nl",
    contactLocale: "YN-nl_NL",
  },
  "www.befr.yoonly.eu": {
    channelId: 108,
    locale: "fr-FR",
    currency: "EUR",
    entity: "yoonly_be_fr",
    contactLocale: "YN-fr_FR",
  },
  "www.benl.yoonly.eu": {
    channelId: 107,
    locale: "nl-NL",
    currency: "EUR",
    entity: "yoonly_be_nl",
    contactLocale: "YN-nl_NL",
  },
  "cse.travelski.com": {
    channelId: 98,
    locale: "fr-FR-CSE",
    currency: "EUR",
    entity: "travelski",
    contactLocale: "TS-fr_FR_CSE",
  },
  "www.travelski.com": {
    channelId: 2,
    locale: "fr-FR",
    currency: "EUR",
    entity: "travelski",
    contactLocale: "TS-fr_FR",
  },
  "express.travelski.com": {
    channelId: 2,
    locale: "fr-FR",
    currency: "EUR",
    entity: "travelski",
    contactLocale: "TS-fr_FR",
  },
  "www.mountaincollection.com": {
    channelId: 2,
    locale: "fr-FR",
    currency: "EUR",
    entity: "travelski",
    contactLocale: "TS-fr_FR",
    partnerKeyEnvVar: "PARTNER_KEY_WWW_MOUNTAINCOLLECTION_COM",
  },
};

export const getWebsiteMapping = (website: string): WebsiteMapping => {
  return websiteMappings[website] ?? websiteMappings[DEFAULT_WEBSITE];
};

export const getPartnerKeyEnvVarForWebsite = (website: string): string | undefined => {
  return getWebsiteMapping(website).partnerKeyEnvVar;
};

export const isPartnerWebsiteSecured = (website: string): boolean => {
  return !!getPartnerKeyEnvVarForWebsite(website);
};

